<script setup lang="ts">
  import { DriverLicence } from '@borg/types';
  import { MpSelect, pushToastMessage } from '@borg/ui';
  import { useUserDriverLicencesStore } from '@/layers/MyProfile/stores/userProfile.store';
  import { EditModalEvents } from './types';

  defineProps<{
    isOpen: boolean;
  }>();

  const emits = defineEmits<EditModalEvents>();

  const { t } = useI18n();
  const userDriverLicencesStore = useUserDriverLicencesStore();

  const { data: driverLicences } = await driverLicencesRepository.getMany();

  const selectedDriverLicences = ref<DriverLicence[]>([]);

  const inProgress = computed(() => userDriverLicencesStore.setManyState === 'inProgress');

  function onModalOpened() {
    selectedDriverLicences.value = userDriverLicencesStore.items;
  }

  async function onSubmit() {
    await userDriverLicencesStore.setMany(selectedDriverLicences.value);
    if (userDriverLicencesStore.setManyState === 'isSuccess') {
      emits('change');
      onClose();
    } else {
      pushToastMessage({
        type: 'alert',
        subtitle: t('MY_PROFILE_PAGE.SUBMIT_ERROR_TOAST.SUBTITLE'),
      });
    }
  }

  function onClose() {
    selectedDriverLicences.value = userDriverLicencesStore.items;
    emits('update:isOpen', false);
  }
</script>

<template>
  <SiteActionsModal
    :is-open="isOpen"
    :title="$t('MY_PROFILE_PAGE.DRIVER_LICENSE_MODAL.TITLE')"
    :in-progress="inProgress"
    @open="onModalOpened"
    @confirm="onSubmit"
    @cancel="onClose"
  >
    <MpSelect
      v-model="selectedDriverLicences"
      :label="$t('MY_PROFILE_PAGE.DRIVER_LICENSE_MODAL.DRIVER_LICENSE_LABEL')"
      :options="driverLicences ?? []"
      :get-value="(option: DriverLicence) => option.id"
      :get-label="(option: DriverLicence) => option.name"
      mode="multiple"
      :max-menu-height="250"
      wrap-tags
      :close-on-select="false"
    />
  </SiteActionsModal>
</template>
